import { Reducer } from 'redux';
import { User } from '../../global';

type FETCH_USER_REQUEST = { type: 'FETCH_USER_REQUEST' };
type FETCH_USER_SUCCESS = { type: 'FETCH_USER_SUCCESS'; payload: User };
type FETCH_USER_FAILED = { type: 'FETCH_USER_FAILED' };

export type UserState = {
  user: User | null;
  loading: boolean;
  success: boolean;
  error: boolean;
};

export type UserStateAction = FETCH_USER_REQUEST | FETCH_USER_SUCCESS | FETCH_USER_FAILED;

export const initialState: UserState = {
  user: null,
  loading: true,
  success: false,
  error: false,
};

const userReducer: Reducer<UserState, UserStateAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_REQUEST':
      return { ...state, success: false, loading: true, error: false };
    case 'FETCH_USER_SUCCESS':
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        user: action.payload,
      };
    case 'FETCH_USER_FAILED':
      return {
        ...state,
        success: false,
        error: true,
        loading: false,
        user: null,
      };
    default:
      return state;
  }
};

export { fetchUser, fetchAllUsers, updateUser, createUser } from './thunks';
export default userReducer;
